/* Maison D'Elite — global theme JS: cart drawer, search overlay, mobile menu, countdown, accordions, reveals */
(function () {
  'use strict';

  var moneyFormatter = function (cents) {
    var format = window.MDE && window.MDE.moneyFormat ? window.MDE.moneyFormat : '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var amount = value.replace(/\.00$/, '');
    if (format.indexOf('amount_no_decimals') > -1) value = Math.round(cents / 100).toString();
    else if (format.indexOf('amount_with_comma_separator') > -1) value = value.replace('.', ',');
    else if (format.indexOf('amount_no_decimals_with_comma_separator') > -1) value = Math.round(cents / 100).toString().replace('.', ',');
    else value = amount;
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  };

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var cartBody = drawer && drawer.querySelector('[data-cart-body]');
  var cartFoot = drawer && drawer.querySelector('[data-cart-foot]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function setCounts(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function lineItemHtml(item) {
    var img = item.image
      ? '<img src="' + item.image + '&width=128" alt="" loading="lazy">'
      : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
    return (
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<div class="cart-line__img">' + img + '</div>' +
        '<div class="cart-line__info">' +
          '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
          variant +
          '<p class="cart-line__price">' + moneyFormatter(item.final_line_price) + '</p>' +
        '</div>' +
        '<div class="cart-line__side">' +
          '<button class="cart-line__remove" data-cart-remove="' + item.key + '" aria-label="Remove ' + item.product_title + '">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/></svg>' +
          '</button>' +
          '<div class="qty-stepper">' +
            '<button data-cart-qty="' + item.key + ':' + (item.quantity - 1) + '" aria-label="Decrease quantity"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14"/></svg></button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-cart-qty="' + item.key + ':' + (item.quantity + 1) + '" aria-label="Increase quantity"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCart(cart) {
    setCounts(cart.item_count);
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<div class="cart-drawer__empty"><div>' +
        '<p class="eyebrow">Your bag is empty</p>' +
        '<p class="serif-italic mt-4" style="color:var(--color-muted-foreground)">The collection awaits.</p>' +
        '</div></div>';
      if (cartFoot) cartFoot.classList.add('hidden');
      return;
    }
    cartBody.innerHTML = cart.items.map(lineItemHtml).join('');
    if (cartFoot) {
      cartFoot.classList.remove('hidden');
      var totalEl = cartFoot.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = moneyFormatter(cart.total_price);
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  /* Add to cart — global, used by product forms and Complete the Look */
  window.MDE = window.MDE || {};
  window.MDE.moneyFormat = window.MDE.moneyFormat || '${{amount}}';
  window.MDE.addToCart = function (items, openAfter) {
    var payload = Array.isArray(items) ? { items: items } : { items: [items] };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { if (openAfter !== false) openDrawer(); });
  };

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn || e.target.classList.contains('cart-drawer__scrim')) { closeDrawer(); return; }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) { changeLine(removeBtn.getAttribute('data-cart-remove'), 0); return; }
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var parts = qtyBtn.getAttribute('data-cart-qty').split(':');
      var qty = parseInt(parts[parts.length - 1], 10);
      var key = parts.slice(0, parts.length - 1).join(':');
      if (qty >= 0) changeLine(key, qty);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeSearch(); closeMenu(); }
  });

  /* ---------------- Search overlay ---------------- */
  var search = document.querySelector('[data-search-overlay]');
  var searchInput = search && search.querySelector('input[type="search"]');
  var searchResults = search && search.querySelector('[data-search-results]');
  var searchTimer = null;

  function openSearch() {
    if (!search) return;
    search.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 80);
  }
  function closeSearch() {
    if (!search) return;
    search.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function predictiveSearch(q) {
    if (!searchResults) return;
    if (!q || q.length < 2) {
      searchResults.innerHTML = '<p class="eyebrow">Type at least 2 characters</p>';
      return;
    }
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchResults.innerHTML = '<p class="serif-italic" style="color:var(--color-muted-foreground)">Nothing found for &ldquo;' + q + '&rdquo;</p>';
          return;
        }
        searchResults.innerHTML = products.map(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<div class="search-result__img"><img src="' + p.featured_image.url + '" alt="" loading="lazy"></div>' : '';
          return (
            '<a class="search-result" href="' + p.url + '">' + img +
              '<div style="min-width:0">' +
                '<div class="search-result__type">' + (p.type || 'Piece') + '</div>' +
                '<div class="search-result__title">' + p.title + '</div>' +
              '</div>' +
              '<span class="search-result__price">' + p.price + '</span>' +
            '</a>'
          );
        }).join('') +
        '<div class="mt-6"><a class="link-arrow" href="/search?q=' + encodeURIComponent(q) + '">View all results &rarr;</a></div>';
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) closeSearch();
  });
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value;
      searchTimer = setTimeout(function () { predictiveSearch(q); }, 250);
    });
  }

  /* ---------------- Mobile menu ---------------- */
  var menu = document.querySelector('[data-mobile-menu]');
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      if (menu) { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-menu-close]')) closeMenu();
  });

  /* ---------------- Accordions ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('.accordion__item');
    var panel = item.querySelector('.accordion__panel');
    var open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  });

  /* ---------------- Password form toggle ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-password-toggle]');
    if (!t) return;
    var form = document.querySelector('[data-password-form]');
    if (form) {
      form.classList.toggle('is-open');
      var input = form.querySelector('input[type="password"]');
      if (input && form.classList.contains('is-open')) input.focus();
    }
  });

  /* ---------------- Countdown ---------------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var d = el.querySelector('[data-cd-days]');
    var h = el.querySelector('[data-cd-hours]');
    var m = el.querySelector('[data-cd-minutes]');
    var s = el.querySelector('[data-cd-seconds]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      if (d) d.textContent = pad(Math.floor(diff / 864e5));
      if (h) h.textContent = pad(Math.floor(diff / 36e5) % 24);
      if (m) m.textContent = pad(Math.floor(diff / 6e4) % 60);
      if (s) s.textContent = pad(Math.floor(diff / 1e3) % 60);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------------- Scroll reveals ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------------- Initial cart count ---------------- */
  refreshCart();
})();
